import { AuthenticateStatus } from '@/config';
import { useUserData } from '@/zustand';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, Grid, Typography } from '@mui/material';
import Link from 'next/link';
import { sm } from 'src/site-map';
import PrimaryButton from '../components/buttons/PrimaryButton';

const HomeHero = () => {
  const isAuthenticated = useUserData(state => state.authenticationStatus === AuthenticateStatus.AUTHENTICATED);
  const isInitializing = useUserData(state => state.isInitializing);

  return (
    <Box
      py={8}
      style={{
        background:
          'linear-gradient(90deg, rgba(0, 149, 255, 0.05) 0%, rgba(111, 255, 0, 0.05) 49.04%, rgba(115, 0, 255, 0.05) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
      }}
    >
      <div className='page__content'>
        <Grid container alignItems={'center'} spacing={5}>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6} item>
            <Typography
              fontSize={{
                xs: 8,
                lg: 12,
              }}
              fontWeight={700}
              textTransform={'uppercase'}
              color='#fff'
              sx={{
                backgroundColor: '#0F5D85',
                display: 'inline-block',
                borderRadius: '10px',
                p: 1,
                letterSpacing: '1px',
              }}
            >
              Procurement software
            </Typography>
            <Typography
              my={2}
              color='#070A0D'
              fontWeight={600}
              component='h1'
              fontSize={{ xs: 40, lg: 64 }}
              lineHeight={0.9}
            >
              Smarter Procurement
            </Typography>
            <Typography
              my={2}
              color='#1D2935'
              fontWeight={400}
              fontSize={{ xs: 12, lg: 16 }}
              lineHeight={1.5}
              maxWidth={'450px'}
            >
              One platform to automate, analyze, and scale your entire procurement process. AI-powered.
              Supplier-connected. Globally scalable.
            </Typography>
            <Box display={'flex'} flexWrap={'wrap'} gap={1}>
              <Link href={isAuthenticated ? sm.portals.index.url : sm.register.index.url} passHref>
                <PrimaryButton
                  sx={{ px: { xs: 4.5, lg: 8 }, py: 2.25, border: '2px solid #005FCC' }}
                  disabled={isInitializing}
                >
                  Get Started
                </PrimaryButton>
              </Link>
              <Link href={'#how-it-works'} passHref scroll={false}>
                <PrimaryButton
                  sx={{
                    px: { xs: 2, lg: 5.5 },
                    py: 2.25,
                    backgroundColor: 'transparent',
                    border: '2px solid #005FCC',
                    color: '#005FCC',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                  variant='text'
                  startIcon={<PlayArrowIcon />}
                >
                  How It Works?
                </PrimaryButton>
              </Link>
            </Box>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6} item>
            <div
              style={{
                position: 'relative',
                width: '100%',
                maxWidth: '600px',
                height: 'auto',
                aspectRatio: '1428 / 960',
                borderRadius: '20px',
                border: '15px solid #000',
                boxShadow: '0px 0px 40px 0px #0017721A',
                overflow: 'hidden',
              }}
            >
              <video
                src='/assets/videos/hero-intro.mp4'
                muted
                autoPlay
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '10px',
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default HomeHero;
